import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Button} from 'components/ui';
import {Tag} from 'letrus-ui';
import {Message} from 'utils/types/messages';
import styles from './MessageCard.module.scss';

interface MessageCardProps {
  message: Message;
  onViewedClick: (message: Message) => void;
}

function MessageCard({message, onViewedClick}: MessageCardProps): JSX.Element {
  return (
    <article key={message.id} className={styles.message}>
      <header className={styles.messageHeader}>
        <div className={styles.messageInfo}>
          <h3 className={styles.messageTitle}>
            {message.sender}
            {!message.seen_by_user && (
              <Tag
                variant="readOnly"
                text="Nova"
                textColor="#FFF"
                backgroundColor="#2563eb"
              />
            )}
          </h3>

          <p className={styles.messageTime}>
            <FontAwesomeIcon icon={['fal', 'clock']} size="sm" />

            {new Date(message.created_at)
              .toLocaleString('pt-BR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: false,
              })
              .replace(',', ' às')}
          </p>
        </div>

        {!message.seen_by_user && (
          <Button
            size="small"
            variant="secondary"
            text="Marcar como lida"
            onClick={() => onViewedClick(message)}
          />
        )}
      </header>

      <p className={styles.messageBody}>{message.text}</p>
    </article>
  );
}

export default MessageCard;
